import { Component, OnInit, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { StreAppDialogComponent } from 'src/app/components/streapp-dialog/streapp-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { BaseOverviewLoader } from '../overview-base/overview-base';
import { isPlatformBrowser } from '@angular/common';
import { StreApp } from 'src/app/models/streapp.model';

@Component({
    selector: 'app-overview-list',
    templateUrl: './overview-list.component.html',
    styleUrls: ['./overview-list.component.scss'],
    standalone: false
})
export class OverviewListComponent extends BaseOverviewLoader implements OnInit, OnDestroy {  
  currentWindowWidth: number = 1920;
  hasScrolled: boolean = false;
  pageTitle: string = 'All';
  showLocationFeatures: boolean = false;
  filter: string = "";
  
  @HostListener("window:scroll", []) onScroll(): void { 
    this.hasScrolled = window.pageYOffset > 0;
  }

  @HostListener("window:resize", []) onResize(): void { 
    this.currentWindowWidth = window.innerWidth;

    if(!this.hasScrollbar() && !this.loading){
      this.loadUntilScrollable();
    }
  }

   async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this._platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }

    super.ngOnInit();
    
    this.streappService.continuationTokenAll = null;
    this.streappService.continuationTokenLocal = null;
    this.noMoreResults = false;
    this.pageSize = 5; //Max on 1 row
    
    this.allStreappsFetched$.pipe()
    .subscribe(() => {
      //Triggered every refresh/reset of allStreapps list
      this.loadUntilScrollable();
    });
    
    if (this.router.url.indexOf('lokaal') > -1) {
      if (isPlatformBrowser(this._platformId)) {
        this.pageTitle = 'Lokaal';
        this.showLocationFeatures = true;
        this.checkForKnownLocation();
      }
    } else {
      this.pageTitle = 'All';
      await this.loadAdsAndEvents();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async onScrollPagination(): Promise<void> {
    // temp blocks local page loading, as pagination does not fully work here as intended yet
    if(this.noMoreResults || this.router.url.indexOf('lokaal') > -1) {
      return;
    }
    await this.loadAdsAndEvents(this.filter);
  }

  async setFilterAndFetch(newFilter: string) : Promise<void>
  {
    this.filter = newFilter;
    await this.loadAdsAndEvents(newFilter);
  }

  //Used with older card (unused)
  navigateToEvent(streapp: StreApp): void {
    this.dialog.open<StreAppDialogComponent, StreApp>(StreAppDialogComponent, {
      data: streapp
    }).afterClosed().pipe(takeUntil(this.destroy$)).subscribe((data: boolean) => {
      if (data) { 
        this.router.navigate(['/detail', streapp.id]);
      }
    });
  }

  loadItemsForMyLocation(): void {
    // Update map location and retrieve new events for this location
    this.mapLocation = {
      long: this.currentLocation.long,
      lat: this.currentLocation.lat
    };
    this.loadAdsAndEvents(this.filter, true);
  }

  loadItemsForNewLocation(location: string): void {
    if (!!location) {
      // Update map location and retrieve new events for this location
      this.mapLocation = {
        long: +location.split(';')[0],
        lat: +location.split(';')[1]
      };
      this.loadAdsAndEvents(this.filter, true);
    }
  }
}
